<template>
    <div class="bodygenerico">
      <div class="bodyFlex">
          <ColunaListaPedidos
          :ojbPedidos="ojbPedidos"
          :buscainicial="query"
          @setarPedido="(pedido) => setarPedido(pedido)"
          urlVideo="https://drive.google.com/file/d/157huWtvjdUkcQsuWsY-WfJaSoCbhmkY1/preview"
          :tela="'COZINHA'"
          />
          <ColunaPedido v-if="pedido" :pedido="pedido"  @imprimirComanda="(pedido) => imprimirComanda(pedido)"
            :exibirnao="true"  @nao="(pedido) =>cancelarPedido(pedido)" @sim="(pedido) => marcarComoPronto(pedido)"
            @getProdutosdoAposLiberacaoPorItem="(numPedido) =>getProdutosdoAposLiberacaoPorItem(numPedido)"
            @marcarItemComoEntregue="(objeto) =>marcarItemComoEntregue(objeto)"
             @carregarPedidos="carregarPedidos"
            :tela="'COZINHA'"
            textonao="Cancelar" textosim="Marcar Como Pronto" perfil="COZINHA" categoria="14" legenda="Dúvidas Cozinha"  urlVideo="https://drive.google.com/file/d/157huWtvjdUkcQsuWsY-WfJaSoCbhmkY1/preview"
              />

            <ColunaListaProdutos v-if="objProdutosTotaisComandas.length && contadorItensComanda" :ojbProdutos="objProdutosTotaisComandas" :tela="'COZINHA'"/>



      </div>

      <!-- <ModalImpressaoPedido :showModal="showModal" :pedidoSelecionado="pedidoSelecionado" /> -->
      <ModalImpressaoPedido  :pedidoSelecionado="pedidoSelecionado" />
      <!-- MODAL IMPRESSAO -->


    </div>
</template>

<script>

import ColunaListaPedidos from '../../components/pedidos/ColunaListaPedidos.vue'
import ColunaPedido from '../../components/pedidos/ColunaPedido.vue'
import ModalImpressaoPedido from '../../components/layout/ModalImpressaoPedido.vue'
import ColunaListaProdutos from '../../components/produtos/ColunaListaProdutos.vue'


const dayjs = require('dayjs')

export default {
  name: 'ViewCozinha',
  components:{
    ColunaListaPedidos,
    ColunaPedido,
    ModalImpressaoPedido,
    ColunaListaProdutos
  },
  data: () => ({
    temposegundo: null,
    exibirTaxa:false,
    // idstatuspadraotela:"3,8",
    idstatuspadraotela:"10",
    ojbPedidos:null,
    pedido:null,
    contadorItensComanda: false,
    showModal:true,
    idsComandas: [],
    objProdutosTotaisComandas: [],
    pedidoSelecionado:{
            nomehotel:localStorage.getItem('nomehotel'),
            idcomanda:0,
            nomehospede:'',
            numerolocal:'',
            datapedido:dayjs().format(),
            quantidade:0,
            precototal:0,
            itens:[{
                    nomeproduto:'',
                    valorunitario:0.00,
                    qtde:0
                }]
        },
    query: '',
  }),
  watch: {
    //quando eu faco uma pesquisa e sou redirecionado para a mesma pagina que estou
    '$route': function(to, from){
      if(to.path == from.path){
        if(to.query.numpedido !== from.query.numpedido){
          this.query = to.query.numpedido
        }
      }
    },
  },
  methods:{
    async carregarPedidos() {
        await this.listarPedidosIniciais(this.idstatuspadraotela)
      },
      continuar(){

          this.$router.push('/Hospede/Menu')
      },
      async getComandasReservaPorStatus(idreservasfront,idstatus){
            let objetoRetorno = {}
            await this.$http('pdv/getComandasReservaPorStatus/'+idreservasfront+'/'+idstatus+'/c').then(async (resp) =>{
              this.idsComandas = resp.data.map((e) => e.numpedido);
              if (this.idsComandas.length) {
                const result = await this.$http.post('pdv/getProdutosDosPedidosTotais', {
                  idsComandas: this.idsComandas,
                  idstatus: 10
                });
                this.objProdutosTotaisComandas = result.data
              } else {
                this.objProdutosTotaisComandas = [];
              }
              objetoRetorno.valorTotal = 0
              objetoRetorno.listadepedidos = resp.data
              for(var i = 0, len = objetoRetorno.listadepedidos.length; i < len; i++){
                  objetoRetorno.valorTotal += parseFloat(objetoRetorno.listadepedidos[i].valor)
                  objetoRetorno.statuscomanda = objetoRetorno.listadepedidos[i].statuscomanda
                  this.exibirTaxa = objetoRetorno.listadepedidos[i].exibirtaxa == 'true' ? true:false
              }
            }).catch(error =>{
              console.log(error)
              this.$alertar("warning","Não foi possivel exibir os pedidos","=(")
            })

            return objetoRetorno
      },
      marcarItemComoEntregue(objeto){

            objeto.pedidoitem.idstatusnovo = 4
            objeto.pedidoitem.notificararea = 'GARCOM'
            this.$http.post('pdv/alterarStatusItem',objeto.pedidoitem).then((resp) =>{
                console.log(resp)
                this.getProdutosdoAposLiberacaoPorItem({idcomanda:objeto.pedidoitem.idcomanda,pedido:objeto.pedido})
            })
            .catch(error =>{
                alert(error)
                console.log(error)
            })

      },
      async getProdutosdoAposLiberacaoPorItem(dados){

        this.pedido = null
        this.pedido = await this.getProdutosdoPedido(dados.idcomanda)

        if(!this.pedido || !this.pedido.listadepedidos || this.pedido.listadepedidos.length == 0){
            this.marcarComoPronto(dados.pedido)
        }
        await this.listarPedidosIniciais(this.idstatuspadraotela)
      },
      async getProdutosdoPedido(numpedido){
            let objetoRetorno = {}
            // await this.$http('pdv/getProdutosdoPedido/'+numpedido+'/c').then((resp) =>{
            await this.$http('pdv/getProdutosdoPedido/'+numpedido+'/c/10').then((resp) =>{
              console.log(resp.data)
              objetoRetorno.valorTotal = 0
              objetoRetorno.numpedido = resp.data[0].idcomanda
              objetoRetorno.datafeito = resp.data[0].datahoraabertura
              objetoRetorno.datarecebido = resp.data[0].datarecebidocozinha
              objetoRetorno.imgassinatura = resp.data[0].imgassinatura
              objetoRetorno.idtipolocal = resp.data[0].idtipolocal
              objetoRetorno.numerolocal = resp.data[0].numerolocal
              objetoRetorno.numreserva = resp.data[0].numreserva
              objetoRetorno.coduh = resp.data[0].coduh
              objetoRetorno.meioprato = resp.data[0].meioprato
              objetoRetorno.nome = resp.data[0].nome
              objetoRetorno.sobrenome = resp.data[0].sobrenome
              objetoRetorno.idgarcominicial = resp.data[0].idgarcominicial
              objetoRetorno.nomegarcominicial = resp.data[0].nomegarcominicial
              objetoRetorno.idgarcomatual = resp.data[0].idgarcomatual
              objetoRetorno.idstatuscomanda = resp.data[0].idstatuscomanda
              objetoRetorno.nomegarcom = resp.data[0].nomegarcom
              objetoRetorno.nomepdv = resp.data[0].nomepdv
              objetoRetorno.passante = resp.data[0].passante
              objetoRetorno.id_tipo_hospede_hits = resp.data[0].id_tipo_hospede_hits
              objetoRetorno.observacaogerais = resp.data[0].observacaogerais

              objetoRetorno.listadepedidos = resp.data
              for(var i = 0, len = resp.data.length; i < len; i++){
                  // objetoRetorno.valorTotal += (parseFloat(resp.data[i].precounitario) * parseFloat(resp.data[i].quantidade))
                  objetoRetorno.valorTotal += (parseFloat(resp.data[i].valortotal))
              }
            }).catch(error =>{
              console.log(error)
              this.$alertar("warning","Não foi possivel exibir os pedidos","=(")
            })

            return objetoRetorno
      },
      async setarPedido(objpedido){
        this.pedido = null
        this.pedido = await this.getProdutosdoPedido(objpedido.numpedido)
        this.pedido.tempocategoria = objpedido.tempocategoria
        this.pedido.temposubcategoria = objpedido.temposubcategoria

        let imagemAssinatura = null

        await this.$http('pdv/getassinaturacomanda/'+objpedido.numpedido).then(resp =>{
                imagemAssinatura= resp.data[0].imgassinatura
            }).catch(error =>{
                console.log(error)
        })

        this.pedidoSelecionado = {
                nomehotel:localStorage.getItem('nomehotel'),
                idcomanda:this.pedido.numpedido,
                nomehospede:this.pedido.nome,
                numerolocal:this.pedido.numerolocal,
                datapedido:dayjs(this.pedido.datafeito).format('DD/MM/YYYY HH:mm'),
                quantidade:this.pedido.listadepedidos.length,
                precototal:this.pedido.valorTotal,
                tempoCategoria:objpedido.tempoCategoria,
                tempoSubCategoria:objpedido.tempoSubCategoria,
                itens:this.pedido.listadepedidos,
                imgassinaturasrc:imagemAssinatura,
                observacaogerais:this.pedido.observacaogerais
            }
      },
      async imprimirComanda() {
            this.showModal = true
            await this.registraLogImpressao()
            setTimeout(() => this.$htmlToPaper('modalImpressao'), 1000);
            // this.$htmlToPaper('modalImpressao')
      },
      async registraLogImpressao() {

        const logMSG = {
          message: "Tentativa de impressão da comanda apartir de botão na web, na qual não interfere no campo flimpresso, a partir da tela de Cozinha",
          pedido: this.pedidoSelecionado,
          tela: "Cozinha"
        }

        const data = {
          tipo: 101,
          idusuario: localStorage.getItem('idusuario'),
          descricao: "Impressão de comanda pelo botão web",
          log: JSON.stringify(logMSG, null, 2),
        }

        await this.$http.post("/pdv/registraLogMovimentacaoCD", data)
      },
      async listarPedidosIniciais(idstatus){
        this.ojbPedidos = await this.getComandasReservaPorStatus(0,idstatus)
        if( this.ojbPedidos.listadepedidos &&  this.ojbPedidos.listadepedidos.length > 0){
            this.ojbPedidos.listadepedidos[0].atrasado= true

            this.exibirTaxa = this.ojbPedidos.listadepedidos[0].exibirtaxa == 'true' ? true:false
            this.pedido = await this.getProdutosdoPedido(this.ojbPedidos.listadepedidos[0].numpedido)
            this.pedido.tempocategoria = this.ojbPedidos.listadepedidos[0].tempocategoria
            this.pedido.temposubcategoria = this.ojbPedidos.listadepedidos[0].temposubcategoria


            let imagemAssinatura= null

            await this.$http('pdv/getassinaturacomanda/'+this.ojbPedidos.listadepedidos[0].numpedido).then(resp =>{
                    imagemAssinatura = resp.data[0].imgassinatura
                }).catch(error =>{
                    console.log(error)
            })
            console.log('this.pedido ',this.pedido)

            this.pedidoSelecionado = {
                      nomehotel:localStorage.getItem('nomehotel'),
                      idcomanda:this.pedido.numpedido,
                      nomehospede:this.pedido.nome,
                      numerolocal:this.pedido.numerolocal,
                      datapedido:dayjs(this.pedido.datafeito).format('DD/MM/YYYY HH:mm'),
                      quantidade:this.pedido.listadepedidos.length,
                      precototal:this.pedido.valorTotal,
                      itens:this.pedido.listadepedidos,
                      imgassinaturasrc:imagemAssinatura,
                      observacaogerais:this.pedido.observacaogerais
                  }
        }else{
           this.pedido = null
        }
      },
      async marcarComoPronto(pedido){

        const data = {
          data_entregue_cozinha: true,
          id_ultimo_usuario_atualizacao: localStorage.getItem("idusuario")
        }

        await this.$http.post(`pdv/alterarStatusPedidoEProdutos/${pedido.numpedido}/4`, data).then(()=>{
          this.$alertar("success","Pedido Liberado!","=)")
          this.listarPedidosIniciais(this.idstatuspadraotela)
          this.pedido = null
        }).catch(()=>{
          this.$alertar("warning","Não foi possível Enviar Pedido Para Garçons ou Bar!","=(")
        })



      },
      async cancelarPedido(pedido){
        console.log("PEDD")
        console.log(pedido)

        const dados = {
          id_ultimo_usuario_atualizacao: localStorage.getItem("idusuario")
        }

        await this.$http.post(`pdv/alterarStatusPedidoEProdutos/${pedido.numpedido}/6`, dados).then(()=>{
           this.$alertar("success","Pedido Cancelado!","=)")
           this.listarPedidosIniciais(this.idstatuspadraotela)
        }).catch(()=>{
          this.$alertar("warning","Não foi possível Cancelar o Pedido!","=(")
        })



      },
  },
  created(){

  },
  async mounted(){

    await this.$http.post('pdv/buscarparametros',{chave:'CONTADOR_ITENS_COMANDAS'})
                .then(resp =>{
                    if(resp.data && resp.data.length > 0){
                        this.contadorItensComanda = resp.data[0].valor === 'true' ? true : false
                    }
                }).catch(error =>{
                    alert(error)
                })

    await this.$http.post('pdv/buscarparametros',{chave:'IMPRESSAOCOZINHA'})
      .then(resp =>{
          if(resp.data && resp.data.length > 0){
              this.temposegundo = resp.data[0].valor6 ?? 5
          }
      }).catch(error =>{
          alert(error)
      })

      this.$store.dispatch("set_titulo", "Cozinha")
      await this.listarPedidosIniciais(this.idstatuspadraotela)

      const self = this

      const notificacaoAparelho = JSON.parse(localStorage.getItem("locaisNotificacao"))

      this.sockets.subscribe('novo_pedido_cozinha', () => {
        if(notificacaoAparelho.includes("COZINHA")) {
          self.$alertar("warning","Novo Pedido Solicitado!","=D", Number(this.temposegundo) * 1000)
        }
        var snd = new Audio("data:audio/wav;base64,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");
        snd.play();
        setTimeout(() => {
          self.listarPedidosIniciais(self.idstatuspadraotela)
        }, 3000);
      })

      // this.sockets.subscribe('notificar_troca_status_pedido',() => {
      //   setTimeout(() => {
      //     self.listarPedidosIniciais(self.idstatuspadraotela)
      //   }, 3000);
      // });

      const { numpedido } = this.$route.query
      if(numpedido){
        this.query = numpedido
        let pedido = this.ojbPedidos.listadepedidos.filter(pedido => pedido.numpedido == numpedido)[0]
        this.setarPedido(pedido)
      }
  },
  beforeDestroy(){
    this.sockets.unsubscribe("novo_pedido_cozinha")
  }
};
</script>


<style scoped>

</style>
